import type { FaireProductEntity } from "../../entity_types/product";

export const p_px934ush8b: FaireProductEntity = {
  token: "p_px934ush8b",
  type: "product",
  name: "Protein Bar Sampler #2 - Variety Pack",
  brandName: "Aloha",
  imageUrl:
    "https://cdn.faire.com/fastly/5220adf2a5329c49db3112bc0ec3b9e3de443ff8391cc0598f3caa4b6f8bc6c3.jpeg",
  priceDollars: 29.58,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/203ce9845ff5329de92fc9be60297729580d427658bbe805fb4c8ed7748be5d4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
